<!-- <app-background-homepage></app-background-homepage> -->
<div class="">
  <mat-dialog-content style="scroll-behavior: unset">
    <p class="stepDisplay assessment_pt-25">
      
      <span>STEP 1/3</span>
    </p>
    <div class="font-14 heading">
      <h4
        style="
          font-family: 'MontSerrat';
          color: #1e2a36;
          font-weight: 600;
          font-size: 24px;
        "
      >
        {{ data?.message }}
      </h4>
    </div>
    <div class="assessment_py-10 font-8">
      <h6
        class="mobile-font"
        style="
          font-family: 'MontSerrat';
          font-weight: 500;
          font-size: 16px;
          color: #748494;
        "
      >
        {{ data?.message2 }}
      </h6>
    </div>
    <form [formGroup]="accountForm">
      <div class="setup-account-input-icons">
        <!-- <img class="setup-account-icon" src="assets/img/email-icon-dark.svg" alt="" /> -->
        <input
          class="form-control setup-account-input-field-left email"
          required
          type="text"
          formControlName="email"
          placeholder="Email"
        />
        <mat-error
          class="error-msg"
          *ngIf="a.email.touched && a.email.errors?.required"
        >
          Required
        </mat-error>
        <mat-error
          class="error-msg"
          *ngIf="a.email.touched && a.email.errors?.pattern"
        >
          Enter valid email
        </mat-error>
      </div>

      <div class="setup-account-input-icons">
        <!-- <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" /> -->
        <input
          oncopy="return false"
          onpaste="return false"
          class="form-control setup-account-input-field-left password"
          [type]="show_button ? 'text' : 'password'"
          formControlName="password"
          placeholder="Password"
        />
        <mat-error
          class="error-msg"
          *ngIf="a.password.touched && a.password.errors?.required"
        >
          Required
        </mat-error>
        <mat-error
          class="error-msg"
          *ngIf="
            a.password.touched &&
            !a.password.errors?.required &&
            (a.password.errors?.minlength || a.password.errors?.pattern)
          "
        >
        Password should contain at least 6 characters(should contain A-Z, a-z, and 0-9)
        </mat-error>
        <!-- <a (click)="showPassword()"><img style="left:900px;top:410px;" src="assets/img/password-eye.svg" alt=""  /></a> -->

        <mat-icon
          class="font-16 cursor-pointer field-icon"
          matSuffix
          (click)="showPassword()"
          >{{ show_button ? "visibility_off" : "visibility" }}</mat-icon
        >
      </div>
      <div class="setup-account-input-icons" style="margin-bottom: 35px">
        <!-- <img class="setup-account-icon" src="assets/img/password-lock.svg" alt="" /> -->
        <input
          oncopy="return false"
          onpaste="return false"
          class="form-control setup-account-input-field-left password"
          [type]="show_eye ? 'text' : 'password'"
          formControlName="confirmpassword"
          placeholder="Confirm Password"
          phone-number
        />
        <mat-error
          class="error-msg"
          *ngIf="
            a.confirmpassword.touched && a.confirmpassword.errors?.required
          "
        >
          Required
        </mat-error>

        <!-- <a (click)="showConfirmPassword()"><img style="left:900px;top:355px;" src="assets/img/password-eye.svg" alt="" /></a> -->
        <mat-icon
          class="font-16 cursor-pointer field-icon"
          matSuffix
          (click)="showConfirmPassword()"
          >{{ show_eye ? "visibility_off" : "visibility" }}</mat-icon
        >
        <mat-error
          class="error-msg"
          *ngIf="
            a.confirmpassword.touched && !a.confirmpassword.errors?.required &&  !isPasswordEqualToConfirmPassword()
          "
        >
        The passwords don’t match, please try again
        </mat-error>
      </div>

      <div class="d-flex justify-content-between align-items-center setup-flex">
        <button
          class="btn btn-primary next-btn-block assessment_ml-0 setup-next"
          type="button"
          (click)="passwordLogin()"
        >
          NEXT
        </button>
        <span class="set-up-later"
          ><a href="javascript:void(0)" (click)="setupLater()"
            >SET UP LATER</a
          ></span
        >
      </div>
    </form>
  </mat-dialog-content>
</div>
